import { AnyAction } from 'models/types'
import { CADASTRO_MODELO, TYPES } from './types'
import { Reducer } from 'redux'

const INITIAL_STATE: CADASTRO_MODELO = {
  activeTab: 'search',
  activeTabRegister: 1,
  pagination: {
    page: 0,
    pageSize: 10,
    totalRegistros: 0
  },
  limiteMaximoRegistros: 500,
  showConfirmacaoExclusao: false,
  visualizacao: false,
  register: { id: '', atalho: '', descricao: '' },
  search: {
    atalho: '',
    descricao: '',
    filtro: ''
  },
  invalids: { atalho: false, descricao: false },
  itemSelectedId: '',
  modeloMensagem: [],
  modeloMensagemSelect: []
}
const reducer: Reducer<CADASTRO_MODELO, AnyAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case TYPES.SET_ACTIVE_TAB:
      return { ...state, activeTab: action.value }
    case TYPES.SET_ACTIVE_TAB_REGISTER:
      return { ...state, activeTabRegister: action.value }
    case TYPES.TOGGLE_MODAL_EXCLUSAO_DISPATCH:
      return {
        ...state,
        showConfirmacaoExclusao: action.value
      }
    case TYPES.SET_ITEM_SELECTED_ID_DISPATCH:
      return {
        ...state,
        itemSelectedId: action.value
      }
    case TYPES.SET_PAGINATION:
      return {
        ...state,
        pagination: action.value
      }
    case TYPES.SET_ALL_CADASTRO_MODELO:
      return {
        ...state,
        modeloMensagem: action.value
      }
    case TYPES.SET_VISUALIZACAO:
      return {
        ...state,
        visualizacao: action.value
      }
    case TYPES.SET_REGISTER_FIELDS:
      return {
        ...state,
        register: { ...state.register, [action.field]: action.value }
      }
    case TYPES.SET_REGISTER:
      return {
        ...state,
        register: action.value
      }
    case TYPES.SET_INVALIDS:
      return {
        ...state,
        invalids: { ...state.invalids, [action.field]: action.value }
      }
    case TYPES.CLEAN_INVALIDS:
      return {
        ...state,
        invalids: INITIAL_STATE.invalids
      }
    case TYPES.CLEAN_REGISTER:
      return { ...state, register: INITIAL_STATE.register }
    case TYPES.SET_PESQUISA:
      return {
        ...state,
        search: { ...state.search, [action.field]: action.value }
      }
    case TYPES.SET_MODELOS_MENSAGEM_SELECT:
      return {
        ...state,
        modeloMensagemSelect: action.value
      }
    default:
      return state
  }
}
export default reducer
